<template>
  <div>
    <div class="header-box flex_between animated fadeIn">
      <img
        class="left-box"
        :src="LogoUrl"
        mode="scaleToFill"
        @click="$router.push('/')"
      />
      <div class="right-box flexalign">
        <el-form
          :inline="true"
          size="small"
          class="header-form"
          style="height: 2rem"
        >
          <el-form-item label="" style="margin: 0">
            <el-input
              v-model="searchVal"
              style=""
              :placeholder="$t('layoutView.headSearchPlaceholder')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="margin: 0">
            <el-button class="search-btn" @click="searchQuery">
              <i class="el-icon-search search-btn"> </i>
            </el-button>
          </el-form-item>
          <el-form-item label="">
            <el-select
              class="langSelect"
              v-model="lang1"
              placeholder=""
              @change="langSelect"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="login-box flexalign">
          <a href="http://wzf.rmbsilkroad.com:9082/login" target="_blank">{{
            $t("layoutView.login")
          }}</a>
          <a href="http://wzf.rmbsilkroad.com:9082/Register" target="_blank">{{
            $t("layoutView.register")
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
export default {
  props: {
    LogoUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: [
        {
          value: "cn",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
        {
          value: "ru",
          label: "Russian",
        },
      ],
      lang1: "cn",
      searchVal: "",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    //去登陆
    toLogin() {
      this.$router.push("/login");
    },
    // 去首页
    toHome() {
      this.$router.push("/");
    },
    //去注册
    toRegister() {
      this.$router.push("/register");
    },
    //去个人中心
    toPersonal() {
      this.$router.push("/personal");
    },
    //搜索关键字
    searchQuery() {
      debugger;
      this.$router.push({
        path: "/cxjg",
        query: {
          keywords: this.searchVal,
        },
      });
    },
    langSelect(val) {
      this.$emit("changeLang", val);
      // this.$store.dispatch('setLanguage', val)
      // localStorage.setItem("lang", val)
    },
  },
  components: {
    Search,
  },
};
</script>

<style scoped lang="scss">
.header-box {
  width: 100rem;
  margin: 0 auto;
  height: 6.25rem;
  position: relative;
  .left-box {
    width: 29.4375rem;
    height: 3.75rem;
  }
  .right-box {
    height: 4.6785rem;
    line-height: 4.6785rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // flex-wrap: wrap;
    .login-box {
      height: 2rem;
      margin-left: 2.5rem;
      font-size: 1rem;
      color: #2a2a2a;
      a {
        margin-right: 1.25rem;
        
      }
    }
    .langSelect {
      width: 6.25rem;
      height: 2rem;
      line-height: 2rem;
      margin-left: 2rem;
      .el-input__inner {
        border-radius: 4px;
        font-size: 0.875px;
      }
    }
  }
  .wel-box {
    flex: 1;
    margin-left: 3.625rem;
    font-weight: 400;
    font-size: 1.25rem; //cs20px
    color: #2a2a2a;
    position: relative;
    // &:before {
    //   content: "";
    //   width: 1px;
    //   height: 80%;
    //   position: absolute;
    //   left: -1.25rem;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   background: #f1f1f1;
    // }
    p,
    span {
      cursor: pointer;
    }
    .avatar {
      width: 1.875rem;
      height: 1.875rem;
      // background: #0366e8;
      margin-right: 0.375rem;
      cursor: pointer;
    }
  }
  .text-box {
    width: 100%;
    position: absolute;
    top: 13.5rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    .title {
      font-size: 4.125rem;
      color: #ffffff;
      text-shadow: 0px 0px 20px rgba(12, 23, 97, 0.88);
    }
    .sub-title {
      width: fit-content;
      font-weight: 300;
      font-size: 2.0625rem;
      color: #ffffff;
      text-align: center;
      text-shadow: 0px 0px 20px rgba(12, 23, 97, 0.88);
      background: rgba(46, 46, 46, 0.8);
      border-radius: 6px 6px 6px 6px;
      padding: 0.875rem 2.5rem;
      margin: 0 auto;
      margin-top: 1rem;
    }
  }
}
</style>
